"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.MobileTileSkeleton = exports.FindYourProductList = exports.FindYourProductLink = exports.DesktopTileSkeleton = exports.CategoryBoxWrapper = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'start',
  flexWrap: 'wrap',
  margin: theme.spacing(0),
  a: {
    width: '160px',
    flex: '0 0 160px'
  },
  [theme.breakpoints.up('md')]: {
    maxWidth: 1110,
    gap: theme.spacing(6),
    margin: theme.spacing(6, 12)
  }
}));
const FindYourProductList = exports.FindYourProductList = (0, _mui.styled)('ul')(({
  theme
}) => ({
  backgroundColor: theme.palette.common.white,
  listStyleType: 'none',
  li: {
    padding: theme.spacing(2, 3, 2, 10)
  }
}));
const CategoryBoxWrapper = exports.CategoryBoxWrapper = (0, _mui.styled)('button')({
  alignSelf: 'start',
  background: 'none',
  padding: 0
});
const FindYourProductLink = exports.FindYourProductLink = (0, _mui.styled)(_mui.Link)(({
  theme
}) => ({
  fontSize: '1.7rem',
  textDecoration: 'none',
  flex: 1,
  [theme.breakpoints.up('md')]: {
    color: theme.palette.text.primary,
    display: 'block',
    lineHeight: '2.1rem',
    textDecoration: 'none'
  },
  '&:hover, &:focus, &:active': {
    color: theme.palette.secondary.main,
    WebkitTapHighlightColor: 'transparent'
  }
}));
const DesktopTileSkeleton = exports.DesktopTileSkeleton = (0, _mui.styled)(_presentationComponents.CategoryBoxSkeleton)({
  width: _presentationComponents.CATEGORY_BOX_DESKTOP_MEDIUM_WIDTH
});
const MobileTileSkeleton = exports.MobileTileSkeleton = (0, _mui.styled)(_mui.Skeleton)(({
  theme
}) => ({
  margin: theme.spacing(2, 3, 2, 10),
  transform: 'initial'
}));